import React from 'react';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router';
import { routes } from '@/constant/routes.const';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { IMG_LOGO_KTP_BLUE, IMG_LOGO_KTP_WHITE } from '@repo/assets';

interface IProps {
  isTop: boolean;
  isMobile?: boolean;
}
function Logo({ isTop, isMobile }: IProps) {
  const { register, passportNumber } = useAppSelector(
    (state) => state,
  ) as IGlobalState;
  const { pathname } = useLocation();
  const history = useHistory();

  const onClick = () => {
    // 첫 화면
    if (pathname === '/') {
      return;
    }
    if (!passportNumber) {
      history.replace(routes.passport);
    }

    if (register) {
      history.replace(routes.home);
    }
    window.scrollTo(0, 0);
  };
  return (
    <LogoWrapper isMobile={isMobile}>
      <SLogo
        alt='Korea Tax Free Payments'
        src={isTop ? IMG_LOGO_KTP_WHITE : IMG_LOGO_KTP_BLUE}
        onClick={onClick}
      />
    </LogoWrapper>
  );
}

const LogoWrapper = styled.div<{ isMobile?: boolean }>`
  position: relative;
  width: 80px;
  height: 22px;
`;

const SLogo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
`;
export default Logo;
